"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allRequestsFinished = exports.anyRequestsPending = exports.allRequestsInitiated = exports.anyRequestsFailed = exports.allFinishedWithSuccess = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var allFinishedWithSuccess = function allFinishedWithSuccess() {
  for (var _len = arguments.length, requestStatuses = new Array(_len), _key = 0; _key < _len; _key++) {
    requestStatuses[_key] = arguments[_key];
  }

  return requestStatuses.every(function (requestStatus) {
    return requestStatus === _RequestStatusTypes.default.SUCCEEDED;
  });
};

exports.allFinishedWithSuccess = allFinishedWithSuccess;

var anyRequestsFailed = function anyRequestsFailed() {
  for (var _len2 = arguments.length, requestStatuses = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    requestStatuses[_key2] = arguments[_key2];
  }

  return requestStatuses.includes(_RequestStatusTypes.default.FAILED);
};

exports.anyRequestsFailed = anyRequestsFailed;

var allRequestsInitiated = function allRequestsInitiated() {
  for (var _len3 = arguments.length, requestStatuses = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    requestStatuses[_key3] = arguments[_key3];
  }

  return requestStatuses.every(function (requestStatus) {
    return typeof requestStatus !== 'undefined' && requestStatus !== _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.allRequestsInitiated = allRequestsInitiated;

var anyRequestsPending = function anyRequestsPending() {
  for (var _len4 = arguments.length, requestStatuses = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    requestStatuses[_key4] = arguments[_key4];
  }

  return requestStatuses.includes(_RequestStatusTypes.default.PENDING);
};

exports.anyRequestsPending = anyRequestsPending;

var allRequestsFinished = function allRequestsFinished() {
  for (var _len5 = arguments.length, requestStatuses = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    requestStatuses[_key5] = arguments[_key5];
  }

  return requestStatuses.every(function (requestStatus) {
    return requestStatus === _RequestStatusTypes.default.SUCCEEDED || requestStatus === _RequestStatusTypes.default.FAILED;
  });
};

exports.allRequestsFinished = allRequestsFinished;